import React from "react";

import Resource from "app/core/resource";

class Viber extends React.Component {
    constructor(props) {
        super(props);

        /**
         * @property _Resource
         * @type {Object}
         * @private
         */
        this._Resource = Resource;
    }

    /**
     * @protected
     * @method render
     * @returns {string}
     */
    render() {
        return (
            <a
                className="social-network-button social-network-button--viber"
                href={this._Resource.links.viberPharmacistConsultation}
                target="_blank"
            >
                <img
                    className="lazyload"
                    src={this._Resource.links.images.viber.previewRounded}
                    alt="Viber"
                    width={38}
                    height={38}
                />

                <span className="social-network-button__name">Viber</span>
            </a>
        );
    }
}

export default Viber;
